<template>
  <img
    src="https://i.pinimg.com/originals/b7/fb/80/b7fb80122cf46d0e584f3a0768aef282.gif"
  />
</template>

<script>
export default {
  name: "home",
};
</script>
